import React from 'react';
import { useLocation } from 'react-router-dom';
import { Settings, Wrench } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';

/**
 * Generic Settings Placeholder - Used for settings pages not yet implemented
 */
const SettingsPlaceholder = ({ title, description, icon: Icon = Settings }) => {
  const location = useLocation();
  
  // Derive title from path if not provided
  const derivedTitle = title || location.pathname.split('/').pop()?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  
  return (
    <div className="min-h-screen bg-[#0B1F18] text-white p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-amber-500/10 rounded-lg">
              <Icon className="h-6 w-6 text-amber-500" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-white">{derivedTitle}</h1>
              <p className="text-[#93AE9F] text-sm">{description || 'Configure settings for this section'}</p>
            </div>
          </div>
        </div>

        <Card className="bg-zinc-900/50 border-zinc-800">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Wrench className="w-5 h-5 text-amber-500" />
                <CardTitle className="text-white">Coming Soon</CardTitle>
              </div>
              <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30">In Development</Badge>
            </div>
            <CardDescription className="text-zinc-400">
              This settings page is currently under development
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-zinc-800/50 flex items-center justify-center">
                <Icon className="w-8 h-8 text-zinc-600" />
              </div>
              <p className="text-zinc-400 mb-2">
                The <span className="text-white font-medium">{derivedTitle}</span> configuration interface is being built.
              </p>
              <p className="text-zinc-500 text-sm">
                Check back soon for updates.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SettingsPlaceholder;
